import React, { useEffect, useState } from 'react';
import { PhotocardForm, Spinner } from '@silverrailtech/srtlibrary';
import { getCustomerAccountData } from '../../../../api';
import ExtendedSnackbar from '../../../../components/ExtendedSnackbar/ExtendedSnackbar';
import useAuth from '../../../../hooks/useAuth';

const PhotoCard = () => {
	const { getAuthHeaders, accountId } = useAuth();
	const [photoCardData, setPhotoCardData] = useState([]);
	const [isPending, setIsPending] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		if (accountId) {
			getCustomerAccountData(
				null,
				getAuthHeaders(),
				`/${accountId}/photocards`,
				() => {
					setIsPending(false);
					setError('Failed to load photo card information');
				},
				(data) => {
					setPhotoCardData(data);
					setIsPending(false);
				},
			);
		}
	}, [accountId, getAuthHeaders]);

	const props = {
		formData: photoCardData,
		showEditButton: false,
	};

	return (
		<>
			<PhotocardForm {...props} />
			<ExtendedSnackbar
				id="srtPhotoCardSnackBar"
				open={error !== ''}
				message={error}
				onClose={() => setError('')}
			/>
			{isPending && <Spinner />}
		</>
	);
};

export default PhotoCard;
